import React, { useEffect, useState } from 'react';
import { pbCategoriesApi } from '../api';

const selectCls = 'bg-[#1A1A1A] border border-gray-700 text-white rounded-md px-3 py-2 text-sm focus:border-[#D4AF37] focus:outline-none';

// Category picker backed by the editable ops_pb_categories registry.
export const CategorySelect = ({ value, onChange, disabled = false, emptyLabel = 'Uncategorized', className = 'w-full', ...props }) => {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    pbCategoriesApi.list().then((r) => setCats(r.data)).catch(() => {});
  }, []);
  const legacy = value && !cats.some((c) => c.name === value);
  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} disabled={disabled} className={`${selectCls} ${className}`} {...props}>
      <option value="">{emptyLabel}</option>
      {legacy && <option value={value}>{value}</option>}
      {cats.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
    </select>
  );
};
